import { t } from '@lingui/macro';

import FormSection from '../../form/FormSection';
import { usePlmMainMenuPages } from '../../side-nav/menus/PlmMainMenuPages';
import ListSelectorField from '../../form/ListSelectorField';
import { useGroupAdminStyles } from './GroupsAdminUtils';
import { GROUPS_ADMIN_PAGES_FIELD, getGroupsAdminPagesColumns } from './GroupsAdminConstants';

export function GroupsAdminPagesSection({ formData, setPagesSelectionIsDirty, isEditingDefaultGroup }) {
    const plmMainMenuPages = usePlmMainMenuPages();
    const styles = useGroupAdminStyles();

    const availableMenuItems = Object.values(plmMainMenuPages).map((menuItem) => ({ _id: menuItem.path, ...menuItem }));

    return (
        <FormSection title={t`Visible Pages`}>
            <div className={styles.selectorWrapper}>
                <ListSelectorField
                    gridColumns={getGroupsAdminPagesColumns(styles)}
                    dataArray={availableMenuItems}
                    dataArraySearchFields={['title']}
                    dbSelected={formData?.pages || availableMenuItems.map((menuItem) => menuItem._id)}
                    fieldName={GROUPS_ADMIN_PAGES_FIELD}
                    addButtonText={t`Add Visible Pages`}
                    removeButtonText={t`Remove`}
                    setSelectionIsDirty={setPagesSelectionIsDirty}
                    selectedEmptyGridText={t`There are no Visible Pages in this Group`}
                    // Disable field and hide actions if user is editing the default group
                    disabled={isEditingDefaultGroup}
                    hideActions={isEditingDefaultGroup}
                />
            </div>
        </FormSection>
    );
}
